module.exports = __webpack_public_path__ + "static/img/home2.f8a7bb62.jpg";